module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dbd049d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackingNotifier/TrackingNotifier.vue
// module id = 3717
// module chunks = 1